<style lang="less">
    @import "../../../../../styles/reset.less";
    @import "../../../../../styles/common-table-list.less";
</style>
<template>
    <div class="center-table-list">
        <div class="table-list">
            <div class="table-list-title">
                <span class="myTitle">增加权利主体</span>
            </div>
            <div class="authentication_type clearfix">
                <div class="authentication_item fl">
                    <div class="authentication_title">
                        AUTHENTICATION
                        <div class="authentication_title_group">
                            <h2 class="authentication_subheading">个人权利主体</h2>
                            <h3 class="authentication_msg">PERSONAL OBLIGEE</h3>
                        </div>
                    </div>
                    <router-link class="authentication_btn" :to="{path:'/addPersonalObligee'}">增加</router-link>
                    <img class="authentication_img fr" src="../authentication/images/personal.png" alt='版权登记'>
                </div>
                <div class="authentication_item fl">
                    <div class="authentication_title">
                        AUTHENTICATION
                        <div class="authentication_title_group">
                            <h2 class="authentication_subheading">企业权利主体</h2>
                            <h3 class="authentication_msg">ENTERPRISE OBLIGEE</h3>
                        </div>
                    </div>
                    <div class="authentication_item_msg">
                        <router-link class="authentication_btn" to="/addEnterpriseObligee">增加</router-link>
                        <img class="authentication_img fr" src="../authentication/images/enterprise.png" alt='版权登记'>
                    </div>
                </div>
            </div>
            <div class="reminder">
                <div class="reminder_title">温馨提示：</div>
                <ul class="reminder_group">
                    <li class="reminder_item">1、个人作者：需要提交个人身份证复印件进行确认您的身份，用于确权、版权登记等平台业务的授权；</li>
                    <li class="reminder_item">2、企业作者：您需要提交企业营业执照、企业授权书；</li>
                </ul>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        metaInfo: {
            title: '添加权利人|前海版权综合服务平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,前海版权综合服务平台,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            },{
                name: 'Description',
                content: '添加权利人,前海版权综合服务平台,人人都是创作者，人人都是版权人。前海版权综合服务平台秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: "addObligee"
    }
</script>

<style scoped lang="less">
    .authentication_type {
        margin: 16px 0 0 20px;
    }

    .authentication_type .authentication_item {
        width: 421px;
        height: 240px;
        background: linear-gradient(135deg, rgba(253, 253, 255, 1) 0%, rgba(250, 251, 253, 1) 100%);
        border-radius: 8px;
        margin-right: 25px;
        position: relative;
    }

    .authentication_type .authentication_item:last-child {
        margin-right: 0;
    }

    .authentication_item .authentication_title {
        position: relative;
        font-family:PingFangSC-Regular,PingFang SC;
        font-size: 48px;
        color: #FAF9FB;
        line-height: 1;
    }
    .authentication_title .authentication_title_group{
        position: absolute;
        left: 25px;
        top: 11px;
    }
    .authentication_title .authentication_subheading{
        color: #333333;
        font-size: 16px;
        line-height: 22px;
        font-weight: bold;
    }
    .authentication_title .authentication_msg{
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        line-height: 17px;
        padding-top: 4px;
    }

    .authentication_item .authentication_btn {
        background: #2196F3;
        width: 104px;
        height: 29px;
        line-height: 29px;
        border-radius: 4px;
        text-align: center;
        color: #fff;
        font-size: 12px;
        position: absolute;
        left: 25px;
        bottom: 25px;
        cursor: pointer;
    }

    .authentication_item .authentication_img {
        margin-right: 19px;
    }

    .reminder {
        padding: 20px 0 0 25px;
        color: #999;
        font-size: 14px;
    }

    .reminder .reminder_group {
        padding-top: 10px;
    }
    .myTitle{
        font-size: 18px !important;
        font-weight: 700;
        position: relative;
        z-index: 2;
        &::before{
            content: '';
            position: absolute;
            width: 50px;
            background: #2196F3;
            height: 6px;
            border-radius: 3px;
            left: 0;
            bottom: 3px;
            z-index: -1;
        }
    }
</style>
